var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2000 1252",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.2121 -2.0194)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 1252,
    "data-background-color": "#ffffff",
    viewBox: "0 0 396 248",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.24 .4)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 247.2,
    viewBox: "0 0 395.52 247.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props)), /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 247.2,
    viewBox: "0 0 395.52 247.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 247.2,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 91.764)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    "data-palette-color": "#134475",
    viewBox: "-2.3 -42.6 346.97 56.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wordmark-text-0",
    d: "m20.4 0.7q-9.45 0-14.57-4.8-5.13-4.8-5.13-15.35 0-20.15 19.6-20.15 4.75 0 8.83 1.15 4.07 1.15 6.07 2.55v12.5h-12v-3.6q0-1.9-0.85-2.8t-2.55-0.9-2.55 0.9-0.85 2.8v15.1q0 1.9 0.85 2.8t2.55 0.9 2.55-0.9 0.85-2.8v-4.05h12v12.95q-2.05 1.4-6.07 2.55-4.03 1.15-8.73 1.15zm37.95-29.2q1 0 1.9 0.2t1.5 0.5v9.55q-2.05-0.85-4.4-0.85-3.15 0-4.85 1.65t-1.7 4.9v4.35h4.5v8.2h-18.2v-8.2h2.2v-11.4h-2.2v-8.2h13.7v3.65q1.4-2.1 3.2-3.23 1.8-1.12 4.35-1.12zm21.2 0.7h13.9v8.2h-1.9l-6.55 17.35q-2.45 6.55-5.6 9.83-3.15 3.27-8.3 3.27-2.1 0-4.25-0.42-2.15-0.43-3.9-1.18v-9.05h6.9v0.5q0 1.25 1.3 1.25 1.15 0 1.75-1.1l-7.9-20.45h-1.9v-8.2h14.85v8.2h-1.7l2.6 7.8 2.4-7.8h-1.7v-8.2zm15.19 38.9v-8.2h2.2v-22.5h-2.2v-8.2h13.7v3.4q1.25-1.6 3.23-2.85 1.97-1.25 4.52-1.25 5.1 0 7.68 3.8 2.57 3.8 2.57 10.8t-2.57 10.8q-2.58 3.8-7.68 3.8-2.55 0-4.52-1.25-1.98-1.25-3.23-2.85v6.3h3.45v8.2h-17.15zm16.6-19.3q1.45 0 2.18-0.77 0.72-0.78 0.72-2.43v-5q0-1.65-0.72-2.42-0.73-0.78-2.18-0.78t-2.17 0.78q-0.73 0.77-0.73 2.42v5q0 1.65 0.73 2.43 0.72 0.77 2.17 0.77zm28.85 8.9q-5.3 0-7.97-2.58-2.68-2.57-2.68-8.67v-9.05h-2.2v-8.2q1.9 0 2.85-0.98 0.95-0.97 0.95-2.67v-2.25h10.6v5.9h6.75v8.2h-6.75v8.2q0 1.65 0.73 2.43 0.72 0.77 2.17 0.77 1.9 0 4.15-0.45v7.85q-1.4 0.55-3.77 1.03-2.38 0.47-4.83 0.47zm25.1 0q-7.1 0-11.1-3.73-4-3.72-4-10.87t4-10.88q4-3.72 11.1-3.72 7.2 0 11.15 3.77 3.95 3.78 3.95 10.83 0 7.15-4 10.87-4 3.73-11.1 3.73zm0-8.9q1.45 0 2.17-0.77 0.73-0.78 0.73-2.43v-5q0-1.65-0.73-2.42-0.72-0.78-2.17-0.78t-2.18 0.78q-0.72 0.77-0.72 2.42v5q0 1.65 0.72 2.43 0.73 0.77 2.18 0.77zm31.6 8.9q-7.1 0-11.1-3.73-4-3.72-4-10.87t4-10.88q4-3.72 11.1-3.72 7.05 0 10.17 3.67 3.13 3.68 3.13 9.13v3.6h-16.2v0.3q0 1.85 1.1 2.72 1.1 0.88 3.65 0.88 3.05 0 5.8-0.45t4.8-1.15v8q-1.75 0.95-5.13 1.72-3.37 0.78-7.32 0.78zm-2.9-18.3h5.8v-0.6q0-1.7-0.73-2.45-0.72-0.75-2.17-0.75t-2.18 0.77q-0.72 0.78-0.72 2.43v0.6zm29.84 18.3q-6.3 0-12.15-2v-7.4h8.1v0.5q0 2.4 3.05 2.4 2.7 0 2.7-1.85 0-1-0.77-1.5-0.78-0.5-2.73-0.85l-2.5-0.45q-7.85-1.4-7.85-8.9 0-4.35 3.3-6.75t8.9-2.4q6.25 0 10.55 2.1v6.95h-7.6v-0.5q0-1-0.67-1.53-0.68-0.52-1.98-0.52-2.5 0-2.5 1.6 0 0.85 0.7 1.3t2.55 0.85l2.85 0.55q4.45 0.85 6.35 3.15t1.9 5.9q0 4.55-3.17 6.95-3.18 2.4-9.03 2.4zm26.15 0q-5.3 0-7.97-2.58-2.68-2.57-2.68-8.67v-9.05h-2.2v-8.2q1.9 0 2.85-0.98 0.95-0.97 0.95-2.67v-2.25h10.6v5.9h6.75v8.2h-6.75v8.2q0 1.65 0.73 2.43 0.72 0.77 2.17 0.77 1.9 0 4.15-0.45v7.85q-1.4 0.55-3.77 1.03-2.38 0.47-4.83 0.47zm37.15-8.9h2.2v8.2h-13.2v-3.4q-1.1 1.6-3.08 2.85-1.97 1.25-4.82 1.25-3.75 0-5.9-2t-2.15-5.65q0-9.45 16.05-9.7-0.15-1.7-1.3-2.33-1.15-0.62-3.9-0.62-2.25 0-4.83 0.47-2.57 0.48-4.72 1.28v-9.2q2.65-0.65 5.75-1.05t6.05-0.4q7.45 0 10.65 2.7t3.2 8.35v9.25zm-11-3.2v-0.3q-2.25 0-3.48 0.6-1.22 0.6-1.22 2 0 0.85 0.52 1.37 0.53 0.53 1.48 0.53 1.3 0 2-1.1t0.7-3.1zm27.15 12.1q-5.3 0-7.98-2.58-2.67-2.57-2.67-8.67v-9.05h-2.2v-8.2q1.9 0 2.85-0.98 0.95-0.97 0.95-2.67v-2.25h10.6v5.9h6.75v8.2h-6.75v8.2q0 1.65 0.72 2.43 0.73 0.77 2.18 0.77 1.9 0 4.15-0.45v7.85q-1.4 0.55-3.78 1.03-2.37 0.47-4.82 0.47zm25.09 0q-7.1 0-11.1-3.73-4-3.72-4-10.87t4-10.88q4-3.72 11.1-3.72 7.05 0 10.18 3.67 3.12 3.68 3.12 9.13v3.6h-16.2v0.3q0 1.85 1.1 2.72 1.1 0.88 3.65 0.88 3.05 0 5.8-0.45t4.8-1.15v8q-1.75 0.95-5.12 1.72-3.38 0.78-7.33 0.78zm-2.9-18.3h5.8v-0.6q0-1.7-0.72-2.45-0.73-0.75-2.18-0.75t-2.17 0.77q-0.73 0.78-0.73 2.43v0.6z",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 5
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m212.79 247.2c-38.644 0-68.435-9.814-89.372-29.443-20.978-19.629-31.467-51.014-31.467-94.157 0-82.4 40.075-123.6 120.23-123.6 19.424 0 37.479 2.351 54.163 7.054 16.644 4.703 29.055 9.917 37.233 15.642v76.675h-73.608v-22.083c0-7.77-1.738-13.495-5.213-17.175-3.476-3.68-8.69-5.521-15.642-5.52-6.952 0-12.166 1.84-15.642 5.52s-5.214 9.405-5.214 17.175v92.624c0 7.77 1.738 13.495 5.214 17.175s8.69 5.521 15.642 5.52c6.952 0 12.166-1.84 15.642-5.52s5.214-9.405 5.213-17.175v-24.843h73.608v79.435c-8.383 5.725-20.794 10.939-37.233 15.642-16.48 4.703-34.33 7.054-53.55 7.054z",
    fill: "#d27b01",
    fontFamily: "none",
    fontSize: "none",
    fontWeight: "none",
    strokeDasharray: "",
    strokeMiterlimit: 10,
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    "data-fill-palette-color": "tertiary"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 91.764)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    viewBox: "0 0 395.52 63.6718612716763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 63.672,
    "data-palette-color": "#134475",
    viewBox: "-2.3 -42.6 346.97 56.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wordmark-text-0",
    d: "m20.4 0.7q-9.45 0-14.57-4.8-5.13-4.8-5.13-15.35 0-20.15 19.6-20.15 4.75 0 8.83 1.15 4.07 1.15 6.07 2.55v12.5h-12v-3.6q0-1.9-0.85-2.8t-2.55-0.9-2.55 0.9-0.85 2.8v15.1q0 1.9 0.85 2.8t2.55 0.9 2.55-0.9 0.85-2.8v-4.05h12v12.95q-2.05 1.4-6.07 2.55-4.03 1.15-8.73 1.15zm37.95-29.2q1 0 1.9 0.2t1.5 0.5v9.55q-2.05-0.85-4.4-0.85-3.15 0-4.85 1.65t-1.7 4.9v4.35h4.5v8.2h-18.2v-8.2h2.2v-11.4h-2.2v-8.2h13.7v3.65q1.4-2.1 3.2-3.23 1.8-1.12 4.35-1.12zm21.2 0.7h13.9v8.2h-1.9l-6.55 17.35q-2.45 6.55-5.6 9.83-3.15 3.27-8.3 3.27-2.1 0-4.25-0.42-2.15-0.43-3.9-1.18v-9.05h6.9v0.5q0 1.25 1.3 1.25 1.15 0 1.75-1.1l-7.9-20.45h-1.9v-8.2h14.85v8.2h-1.7l2.6 7.8 2.4-7.8h-1.7v-8.2zm15.19 38.9v-8.2h2.2v-22.5h-2.2v-8.2h13.7v3.4q1.25-1.6 3.23-2.85 1.97-1.25 4.52-1.25 5.1 0 7.68 3.8 2.57 3.8 2.57 10.8t-2.57 10.8q-2.58 3.8-7.68 3.8-2.55 0-4.52-1.25-1.98-1.25-3.23-2.85v6.3h3.45v8.2h-17.15zm16.6-19.3q1.45 0 2.18-0.77 0.72-0.78 0.72-2.43v-5q0-1.65-0.72-2.42-0.73-0.78-2.18-0.78t-2.17 0.78q-0.73 0.77-0.73 2.42v5q0 1.65 0.73 2.43 0.72 0.77 2.17 0.77zm28.85 8.9q-5.3 0-7.97-2.58-2.68-2.57-2.68-8.67v-9.05h-2.2v-8.2q1.9 0 2.85-0.98 0.95-0.97 0.95-2.67v-2.25h10.6v5.9h6.75v8.2h-6.75v8.2q0 1.65 0.73 2.43 0.72 0.77 2.17 0.77 1.9 0 4.15-0.45v7.85q-1.4 0.55-3.77 1.03-2.38 0.47-4.83 0.47zm25.1 0q-7.1 0-11.1-3.73-4-3.72-4-10.87t4-10.88q4-3.72 11.1-3.72 7.2 0 11.15 3.77 3.95 3.78 3.95 10.83 0 7.15-4 10.87-4 3.73-11.1 3.73zm0-8.9q1.45 0 2.17-0.77 0.73-0.78 0.73-2.43v-5q0-1.65-0.73-2.42-0.72-0.78-2.17-0.78t-2.18 0.78q-0.72 0.77-0.72 2.42v5q0 1.65 0.72 2.43 0.73 0.77 2.18 0.77zm31.6 8.9q-7.1 0-11.1-3.73-4-3.72-4-10.87t4-10.88q4-3.72 11.1-3.72 7.05 0 10.17 3.67 3.13 3.68 3.13 9.13v3.6h-16.2v0.3q0 1.85 1.1 2.72 1.1 0.88 3.65 0.88 3.05 0 5.8-0.45t4.8-1.15v8q-1.75 0.95-5.13 1.72-3.37 0.78-7.32 0.78zm-2.9-18.3h5.8v-0.6q0-1.7-0.73-2.45-0.72-0.75-2.17-0.75t-2.18 0.77q-0.72 0.78-0.72 2.43v0.6zm29.84 18.3q-6.3 0-12.15-2v-7.4h8.1v0.5q0 2.4 3.05 2.4 2.7 0 2.7-1.85 0-1-0.77-1.5-0.78-0.5-2.73-0.85l-2.5-0.45q-7.85-1.4-7.85-8.9 0-4.35 3.3-6.75t8.9-2.4q6.25 0 10.55 2.1v6.95h-7.6v-0.5q0-1-0.67-1.53-0.68-0.52-1.98-0.52-2.5 0-2.5 1.6 0 0.85 0.7 1.3t2.55 0.85l2.85 0.55q4.45 0.85 6.35 3.15t1.9 5.9q0 4.55-3.17 6.95-3.18 2.4-9.03 2.4zm26.15 0q-5.3 0-7.97-2.58-2.68-2.57-2.68-8.67v-9.05h-2.2v-8.2q1.9 0 2.85-0.98 0.95-0.97 0.95-2.67v-2.25h10.6v5.9h6.75v8.2h-6.75v8.2q0 1.65 0.73 2.43 0.72 0.77 2.17 0.77 1.9 0 4.15-0.45v7.85q-1.4 0.55-3.77 1.03-2.38 0.47-4.83 0.47zm37.15-8.9h2.2v8.2h-13.2v-3.4q-1.1 1.6-3.08 2.85-1.97 1.25-4.82 1.25-3.75 0-5.9-2t-2.15-5.65q0-9.45 16.05-9.7-0.15-1.7-1.3-2.33-1.15-0.62-3.9-0.62-2.25 0-4.83 0.47-2.57 0.48-4.72 1.28v-9.2q2.65-0.65 5.75-1.05t6.05-0.4q7.45 0 10.65 2.7t3.2 8.35v9.25zm-11-3.2v-0.3q-2.25 0-3.48 0.6-1.22 0.6-1.22 2 0 0.85 0.52 1.37 0.53 0.53 1.48 0.53 1.3 0 2-1.1t0.7-3.1zm27.15 12.1q-5.3 0-7.98-2.58-2.67-2.57-2.67-8.67v-9.05h-2.2v-8.2q1.9 0 2.85-0.98 0.95-0.97 0.95-2.67v-2.25h10.6v5.9h6.75v8.2h-6.75v8.2q0 1.65 0.72 2.43 0.73 0.77 2.18 0.77 1.9 0 4.15-0.45v7.85q-1.4 0.55-3.78 1.03-2.37 0.47-4.82 0.47zm25.09 0q-7.1 0-11.1-3.73-4-3.72-4-10.87t4-10.88q4-3.72 11.1-3.72 7.05 0 10.18 3.67 3.12 3.68 3.12 9.13v3.6h-16.2v0.3q0 1.85 1.1 2.72 1.1 0.88 3.65 0.88 3.05 0 5.8-0.45t4.8-1.15v8q-1.75 0.95-5.12 1.72-3.38 0.78-7.33 0.78zm-2.9-18.3h5.8v-0.6q0-1.7-0.72-2.45-0.73-0.75-2.18-0.75t-2.17 0.77q-0.73 0.78-0.73 2.43v0.6z",
    fill: "#134475",
    "data-fill-palette-color": "primary"
  }))))))))))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 247.2,
    fill: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bd2deaf40f21f57cd102363903ce4fdb.svg";
export { ForwardRef as ReactComponent };